import { combineReducers } from 'redux';
import { spin } from './spin';

const rootReducer = combineReducers({
	spin
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js